"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var lodash_1 = __importDefault(require("lodash"));

var remote_followed_groups_1 = __importDefault(require("../constants/actions/remote-followed-groups"));

var UtilsArray = __importStar(require("../utils/array"));

var auth_1 = __importDefault(require("../constants/actions/auth"));

var UtilsRemoteFollowedGroups = __importStar(require("../utils/remote-followed-groups"));

function default_1() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    list: [],
    error_on_follow: null,
    error_on_fetch: null,
    error_on_unfollow: null,
    error_on_unfollow_by_id: null,
    error_on_reload: null,
    is_reloading: false,
    is_loading: false
  };
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case remote_followed_groups_1.default.FOLLOW_INIT:
      return Object.assign({}, state, {
        is_loading: true,
        error_on_follow: null
      });

    case remote_followed_groups_1.default.FOLLOW_SUCCESS:
      {
        return Object.assign({}, state, {
          list: UtilsRemoteFollowedGroups.sortByEditAt(UtilsArray.concatAndUnion(state.list, action.data, 'id')),
          is_loading: false
        });
      }

    case remote_followed_groups_1.default.FOLLOW_FAILURE:
      return Object.assign({}, state, {
        is_loading: false,
        error_on_follow: action.error
      });

    case remote_followed_groups_1.default.UNFOLLOW_INIT:
      return Object.assign({}, state, {
        is_loading: true,
        error_on_unfollow: null
      });

    case remote_followed_groups_1.default.UNFOLLOW_SUCCESS:
      {
        return Object.assign({}, state, {
          list: lodash_1.default.filter(state.list, function (u) {
            return u.group_id !== action.group_id;
          }),
          is_loading: false
        });
      }

    case remote_followed_groups_1.default.UNFOLLOW_FAILURE:
      return Object.assign({}, state, {
        is_loading: false,
        error_on_unfollow: action.error
      });

    case remote_followed_groups_1.default.UNFOLLOW_BY_ID_INIT:
      return Object.assign({}, state, {
        is_loading: true,
        error_on_unfollow_by_id: null
      });

    case remote_followed_groups_1.default.UNFOLLOW_BY_ID_SUCCESS:
      {
        return Object.assign({}, state, {
          list: lodash_1.default.filter(state.list, function (u) {
            return u.id !== action.id;
          }),
          is_loading: false
        });
      }

    case remote_followed_groups_1.default.UNFOLLOW_BY_ID_FAILURE:
      return Object.assign({}, state, {
        is_loading: false,
        error_on_unfollow_by_id: action.error
      });

    case remote_followed_groups_1.default.FETCH_INIT:
      return Object.assign({}, state, {
        is_loading: true,
        error_on_fetch: null
      });

    case remote_followed_groups_1.default.FETCH_SUCCESS:
      return Object.assign({}, state, {
        list: UtilsArray.concatAndUnion(state.list, action.list, 'id'),
        is_loading: false
      });

    case remote_followed_groups_1.default.FETCH_FAILURE:
      return Object.assign({}, state, {
        is_loading: false,
        error_on_fetch: action.error
      });

    case remote_followed_groups_1.default.RELOAD_INIT:
      return Object.assign({}, state, {
        is_reloading: true,
        list: [],
        error_on_reload: null
      });

    case remote_followed_groups_1.default.RELOAD_SUCCESS:
      return Object.assign({}, state, {
        is_reloading: false,
        list: action.list
      });

    case remote_followed_groups_1.default.RELOAD_FAILURE:
      return Object.assign({}, state, {
        is_reloading: false,
        error_on_reload: action.error
      });

    case auth_1.default.SIGN_OUT_SUCCESS:
      return Object.assign({}, state, {
        list: []
      });

    default:
      return state;
  }
}

exports.default = default_1;